export default __webpack_public_path__ + "static/media/guide04.50685935.png";